<template>
    <div class="my_order my_store_detail">
        <section class="breadcrumb-section">
            <div class="container">
                <nav aria-label="breadcrumb">
                    <ol class="breadcrumb">
                        <li class="breadcrumb-item"><a href="#">Home</a></li>
                        <li class="breadcrumb-item active" aria-current="page">
                            Cart
                        </li>
                    </ol>
                </nav>
            </div>
        </section>
        <section class="myorder_section">
            <div class="container">
                <div class="row">
                    <div class="col-md-12">
                        <div class="dashboard_design d-md-flex mb_82">
                            <div class="side_bar px-0 sidebar_desk">
                                <ul class="side_bar_links mt_2 p-0">
                                    <li>
                                        <a href="#" class="active"
                                            ><img
                                                src="/maincss/images/myorder.svg"
                                                alt=" "
                                                class="side_bar_icon"
                                            />My Orders</a
                                        >
                                    </li>
                                    <li>
                                        <a href="#" class=""
                                            ><img
                                                src="/maincss/images/saved_design.svg"
                                                alt=" "
                                                class="side_bar_icon"
                                            />Saved Designs</a
                                        >
                                    </li>
                                    <li>
                                        <a href="#" class=""
                                            ><img
                                                src="/maincss/images/upload_img.svg"
                                                alt=" "
                                                class="side_bar_icon"
                                            />Uploaded Images</a
                                        >
                                    </li>
                                    <li>
                                        <a href="#" class=""
                                            ><img
                                                src="/maincss/images/payement.svg"
                                                alt=" "
                                                class="side_bar_icon"
                                            />Payment Options</a
                                        >
                                    </li>
                                    <li>
                                        <a href="#" class=""
                                            ><img
                                                src="/maincss/images/fav.svg"
                                                alt=" "
                                                class="side_bar_icon"
                                            />Favorite</a
                                        >
                                    </li>
                                    <li>
                                        <a href="#" class=""
                                            ><img
                                                src="/maincss/images/edit_profile.svg"
                                                alt=" "
                                                class="side_bar_icon"
                                            />Edit Profile</a
                                        >
                                    </li>
                                    <li>
                                        <a href="#" class=""
                                            ><img
                                                src="/maincss/images/mystore.svg"
                                                alt=" "
                                                class="side_bar_icon"
                                            />My Store</a
                                        >
                                    </li>
                                    <li>
                                        <a href="#" class=""
                                            ><img
                                                src="/maincss/images/manage_payment.svg"
                                                alt=" "
                                                class="side_bar_icon"
                                            />Manage Player</a
                                        >
                                    </li>
                                    <li>
                                        <a href="#" class=""
                                            ><img
                                                src="/maincss/images/manage_team.svg"
                                                alt=" "
                                                class="side_bar_icon"
                                            />Manage Team</a
                                        >
                                    </li>
                                    <li>
                                        <a href="#" class=""
                                            ><img
                                                src="/maincss/images/logout.svg"
                                                alt=" "
                                                class="side_bar_icon"
                                            />Logout</a
                                        >
                                    </li>
                                </ul>
                            </div>
                            <div class="sidebar_mobile">
                                <a class="dropdown-toggle" id="item2" href="#"
                                    >My Account</a
                                >
                                <div class="side_bar px-0">
                                    <ul
                                        id="submenu2"
                                        class="side_bar_links mt_2 p-0 dropdown"
                                    >
                                        <li>
                                            <a href="#" class="active"
                                                ><img
                                                    src="/maincss/images/myorder.svg"
                                                    alt=" "
                                                    class="side_bar_icon"
                                                />My Orders</a
                                            >
                                        </li>
                                        <li>
                                            <a href="#" class=""
                                                ><img
                                                    src="/maincss/images/saved_design.svg"
                                                    alt=" "
                                                    class="side_bar_icon"
                                                />Saved Designs</a
                                            >
                                        </li>
                                        <li>
                                            <a href="#" class=""
                                                ><img
                                                    src="/maincss/images/upload_img.svg"
                                                    alt=" "
                                                    class="side_bar_icon"
                                                />Uploaded Images</a
                                            >
                                        </li>
                                        <li>
                                            <a href="#" class=""
                                                ><img
                                                    src="/maincss/images/payement.svg"
                                                    alt=" "
                                                    class="side_bar_icon"
                                                />Payment Options</a
                                            >
                                        </li>
                                        <li>
                                            <a href="#" class=""
                                                ><img
                                                    src="/maincss/images/fav.svg"
                                                    alt=" "
                                                    class="side_bar_icon"
                                                />Favorite</a
                                            >
                                        </li>
                                        <li>
                                            <a href="#" class=""
                                                ><img
                                                    src="/maincss/images/edit_profile.svg"
                                                    alt=" "
                                                    class="side_bar_icon"
                                                />Edit Profile</a
                                            >
                                        </li>
                                        <li>
                                            <a href="#" class=""
                                                ><img
                                                    src="/maincss/images/mystore.svg"
                                                    alt=" "
                                                    class="side_bar_icon"
                                                />My Store</a
                                            >
                                        </li>
                                        <li>
                                            <a href="#" class=""
                                                ><img
                                                    src="/maincss/images/manage_payment.svg"
                                                    alt=" "
                                                    class="side_bar_icon"
                                                />Manage Player</a
                                            >
                                        </li>
                                        <li>
                                            <a href="#" class=""
                                                ><img
                                                    src="/maincss/images/manage_team.svg"
                                                    alt=" "
                                                    class="side_bar_icon"
                                                />Manage Team</a
                                            >
                                        </li>
                                        <li>
                                            <a href="#" class=""
                                                ><img
                                                    src="/maincss/images/logout.svg"
                                                    alt=" "
                                                    class="side_bar_icon"
                                                />Logout</a
                                            >
                                        </li>
                                    </ul>
                                </div>
                            </div>
                            <div class="left_panel">
                                <h2 class="font_size_20">Store Details</h2>
                                <div class="card_content mb_30">
                                    <div class="card_body py_34 px_36 mt_30">
                                        <h3 class="">
                                            Carlsbad High School, Carlsbad CA
                                        </h3>
                                        <div class="sub_text">
                                            <a
                                                href="#"
                                                class="color-black mr_16"
                                                ><img
                                                    class="mr_8"
                                                    alt=""
                                                    src="/maincss/images/icons/placeholder.svg"
                                                />Montgomery</a
                                            >
                                            •
                                            <span class="mx_16"
                                                ><span class="font-b"
                                                    >Club Name:</span
                                                >
                                                La Crosse Team Booster,
                                                Participants 75</span
                                            >
                                            •
                                            <span class="mx_16"
                                                ><span class="font-b"
                                                    >Team Type:</span
                                                >
                                                LaCrosse</span
                                            >
                                        </div>

                                        <div class="store-type mt_40">
                                            <div class="row">
                                                <div class="col">
                                                    <div
                                                        class="sub_text1 text-uppercase"
                                                    >
                                                        Store Type
                                                    </div>
                                                    <div class="type_name">
                                                        La Crosse
                                                    </div>
                                                </div>
                                                <div class="col">
                                                    <div
                                                        class="sub_text1 text-uppercase"
                                                    >
                                                        Participants
                                                    </div>
                                                    <div class="type_name">
                                                        75
                                                    </div>
                                                </div>
                                                <div class="col">
                                                    <div
                                                        class="sub_text1 text-uppercase"
                                                    >
                                                        Team Names
                                                    </div>
                                                    <div class="type_name">
                                                        Freshmen, JV, Varsity
                                                    </div>
                                                </div>
                                                <div class="col pl_60">
                                                    <div
                                                        class="sub_text1 text-uppercase"
                                                    >
                                                        Start Date
                                                    </div>
                                                    <div class="type_name">
                                                        Feb 24, 2021
                                                    </div>
                                                </div>
                                                <div class="col pl_60">
                                                    <div
                                                        class="sub_text1 text-uppercase"
                                                    >
                                                        End Date
                                                    </div>
                                                    <div class="type_name">
                                                        Mar 19, 2021
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>

                                <div class="panel_main_box">
                                    <div class="row">
                                        <div class="col-sm-6 col-lg-6 col-xl-3">
                                            <div class="graph_img text-center">
                                                <img
                                                    alt=""
                                                    src="/maincss/images/graph.png"
                                                />
                                            </div>
                                        </div>

                                        <div class="col-sm-6 col-lg-6 col-xl-3">
                                            <div class="total_order_box">
                                                <div class="box_left">
                                                    <div class="order_box_num">
                                                        <h3>12</h3>
                                                    </div>
                                                    <div class="order-text">
                                                        In Progress
                                                    </div>
                                                </div>
                                                <div class="box_img">
                                                    <img
                                                        alt=""
                                                        src="/maincss/images/inprogress.svg"
                                                    />
                                                </div>
                                            </div>
                                        </div>

                                        <div class="col-sm-6 col-lg-6 col-xl-3">
                                            <div class="total_order_box">
                                                <div class="box_left">
                                                    <div class="order_box_num">
                                                        <h3>180</h3>
                                                    </div>
                                                    <div class="order-text">
                                                        Completed
                                                    </div>
                                                </div>
                                                <div class="box_img">
                                                    <img
                                                        alt=""
                                                        src="/maincss/images/completed.svg"
                                                    />
                                                </div>
                                            </div>
                                        </div>

                                        <div class="col-sm-6 col-lg-6 col-xl-3">
                                            <div class="total_order_box">
                                                <div class="box_left">
                                                    <div class="order_box_num">
                                                        <h3>08</h3>
                                                    </div>
                                                    <div class="order-text">
                                                        Back Order
                                                    </div>
                                                </div>
                                                <div class="box_img">
                                                    <img
                                                        alt=""
                                                        src="/maincss/images/back_order.svg"
                                                    />
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>

                                <div class="table_layout" id="tabs">
                                    <div class="container">
                                        <div class="row">
                                            <div class="col-lg-12 col-xl-5">
                                                <nav class="table_tab">
                                                    <div
                                                        class="nav nav-tabs nav-fill"
                                                        id="nav-tab"
                                                        role="tablist"
                                                    >
                                                        <a
                                                            class="nav-item nav-link"
                                                            id="nav-home-tab"
                                                            data-toggle="tab"
                                                            href="#nav-home"
                                                            role="tab"
                                                            aria-controls="nav-home"
                                                            aria-selected="true"
                                                            >New Orders</a
                                                        >
                                                        <a
                                                            class="nav-item nav-link"
                                                            id="nav-profile-tab"
                                                            data-toggle="tab"
                                                            href="#nav-profile"
                                                            role="tab"
                                                            aria-controls="nav-profile"
                                                            aria-selected="false"
                                                            >Recent Orders</a
                                                        >
                                                        <a
                                                            class="nav-item nav-link active"
                                                            id="nav-contact-tab"
                                                            data-toggle="tab"
                                                            href="#nav-contact"
                                                            role="tab"
                                                            aria-controls="nav-contact"
                                                            aria-selected="false"
                                                            >All Orders (200)</a
                                                        >
                                                    </div>
                                                </nav>
                                            </div>
                                            <div class="col-lg-12 col-xl-7">
                                                <div class="search_area d-flex">
                                                    <div class="search-area">
                                                        <form
                                                            class="search-form-inline"
                                                        >
                                                            <input
                                                                type="search"
                                                                placeholder="Search"
                                                                aria-label="Search"
                                                                class="search-form-control"
                                                            /><button
                                                                type="submit"
                                                                class="search-btn"
                                                            >
                                                                <img
                                                                    src="/maincss/images/Icon_feather-search.svg"
                                                                    alt="logo"
                                                                    class="headerlogo"
                                                                /></button
                                                            ><a
                                                                class="search-btn search_close"
                                                            ></a>
                                                        </form>
                                                    </div>
                                                    <div class="select_option">
                                                        <label>Region</label>
                                                        <select>
                                                            <option
                                                                value=""
                                                                disabled=""
                                                                selected="select"
                                                            >
                                                                Select
                                                            </option>
                                                            <option
                                                                value="Select"
                                                            >
                                                                Select
                                                            </option>
                                                            <option
                                                                value="Select"
                                                            >
                                                                Select
                                                            </option>
                                                        </select>
                                                    </div>
                                                    <div
                                                        class="select_option sec_opt"
                                                    >
                                                        <label>Show</label>
                                                        <select>
                                                            <option
                                                                value=""
                                                                disabled=""
                                                                selected="select"
                                                            >
                                                                All
                                                            </option>
                                                            <option
                                                                value="In Progress"
                                                            >
                                                                In Progress
                                                            </option>
                                                            <option
                                                                value="Completed"
                                                            >
                                                                Completed
                                                            </option>
                                                            <option
                                                                value="Missing Artwork"
                                                            >
                                                                Missing Artwork
                                                            </option>
                                                            <option
                                                                value="Artwork Proof Pending"
                                                            >
                                                                Artwork Proof
                                                                Pending
                                                            </option>
                                                            <option
                                                                value="Payment Needed"
                                                            >
                                                                Payment Needed
                                                            </option>
                                                            <option
                                                                value="Back Order"
                                                            >
                                                                Back Order
                                                            </option>
                                                        </select>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <div
                                        class="tab-content py-3 px-3 px-sm-0"
                                        id="nav-tabContent"
                                    >
                                        <div
                                            class="tab-pane fade"
                                            id="nav-home"
                                            role="tabpanel"
                                            aria-labelledby="nav-home-tab"
                                        >
                                            <div
                                                class="account_table table-responsive mt_30"
                                            >
                                                <table class="table">
                                                    <thead>
                                                        <tr>
                                                            <th
                                                                class="d-flex order_id_column"
                                                                scope="col"
                                                            >
                                                                <form action="">
                                                                    <input
                                                                        type="checkbox"
                                                                        id=""
                                                                        name=""
                                                                        value=""
                                                                    />
                                                                </form>
                                                                ORDER ID
                                                            </th>
                                                            <th scope="col">
                                                                ARTWORK
                                                            </th>
                                                            <th scope="col">
                                                                <a href="#"
                                                                    >PRODUCT
                                                                    NAME
                                                                    <img
                                                                        alt=""
                                                                        src="/maincss/images/up-down-arrow.svg"
                                                                /></a>
                                                            </th>
                                                            <th scope="col">
                                                                QUANTITY
                                                            </th>
                                                            <th scope="col">
                                                                TOTAL COST
                                                            </th>
                                                            <th scope="col">
                                                                ORDERED ON
                                                            </th>
                                                            <th
                                                                class="status_btn"
                                                                scope="col"
                                                            >
                                                                STATUS
                                                            </th>
                                                        </tr>
                                                    </thead>
                                                    <tbody>
                                                        <tr>
                                                            <td>
                                                                <a
                                                                    class="track_link"
                                                                    href="#"
                                                                >
                                                                    <div
                                                                        class="track_id d-flex"
                                                                    >
                                                                        <div
                                                                            class="track_id_content"
                                                                        >
                                                                            <form
                                                                                action=""
                                                                            >
                                                                                <input
                                                                                    type="checkbox"
                                                                                    id=""
                                                                                    name=""
                                                                                    value=""
                                                                                />110004100
                                                                            </form>
                                                                            <p
                                                                                class="text-right"
                                                                            >
                                                                                24
                                                                                Hour
                                                                                T-Shirt
                                                                            </p>
                                                                        </div>
                                                                        <img
                                                                            src="/maincss/images/info.svg"
                                                                            alt=" "
                                                                        />
                                                                    </div>
                                                                </a>
                                                            </td>
                                                            <td>
                                                                <div
                                                                    class="cloth_img"
                                                                >
                                                                    <img
                                                                        src="/maincss/images/black_tshirt.png"
                                                                        alt=" "
                                                                    />
                                                                    <p>Print</p>
                                                                </div>
                                                            </td>
                                                            <td>
                                                                <div
                                                                    class="port_comp d-flex"
                                                                >
                                                                    <img
                                                                        src="/maincss/images/black_tshirt.png"
                                                                        alt=" "
                                                                    />
                                                                    Port &
                                                                    company…
                                                                </div>
                                                            </td>
                                                            <td>2</td>
                                                            <td>$18.00</td>
                                                            <td>
                                                                Dec 29, 2020
                                                            </td>
                                                            <td>
                                                                <div
                                                                    class="table_btn"
                                                                >
                                                                    <a
                                                                        href="#"
                                                                        class="btn"
                                                                        >In
                                                                        Progress</a
                                                                    >
                                                                    <a
                                                                        class="three_dots"
                                                                        href="#"
                                                                        ><img
                                                                            src="/maincss/images/threedots.svg"
                                                                    /></a>
                                                                </div>
                                                            </td>
                                                        </tr>
                                                    </tbody>
                                                    <tbody>
                                                        <tr>
                                                            <td>
                                                                <a
                                                                    class="track_link"
                                                                    href="#"
                                                                >
                                                                    <div
                                                                        class="track_id d-flex"
                                                                    >
                                                                        <div
                                                                            class="track_id_content"
                                                                        >
                                                                            <form
                                                                                action=""
                                                                            >
                                                                                <input
                                                                                    type="checkbox"
                                                                                    id=""
                                                                                    name=""
                                                                                    value=""
                                                                                />110051025
                                                                            </form>
                                                                        </div>
                                                                    </div>
                                                                </a>
                                                            </td>
                                                            <td>
                                                                <div
                                                                    class="cloth_img"
                                                                >
                                                                    <img
                                                                        src="/maincss/images/custome_classes.png"
                                                                        alt=" "
                                                                    />
                                                                    <p>
                                                                        Embroidery
                                                                    </p>
                                                                </div>
                                                            </td>
                                                            <td>
                                                                <div
                                                                    class="port_comp d-flex"
                                                                >
                                                                    <img
                                                                        src="/maincss/images/custome_classes.png"
                                                                        alt=" "
                                                                    />
                                                                    Custom
                                                                    classic,,,
                                                                </div>
                                                                <div
                                                                    class="bell_icon_text text-center position-relative"
                                                                >
                                                                    <a href="#"
                                                                        ><img
                                                                            src="/maincss/images/bell_icon.svg"
                                                                            alt=" "
                                                                        />
                                                                        Order
                                                                        status
                                                                        reports</a
                                                                    >
                                                                    <div
                                                                        class="table_dropdown"
                                                                    >
                                                                        <div
                                                                            class="dropdown_header_custome"
                                                                        >
                                                                            <h4
                                                                                class="link font_size_14 text_primary_blue py_6 px_8"
                                                                            >
                                                                                Note
                                                                            </h4>
                                                                        </div>
                                                                        <div
                                                                            class="dropdown_para"
                                                                        >
                                                                            <p
                                                                                class="font_size_12 py_6 px_8 mb-0"
                                                                            >
                                                                                Lorem
                                                                                Ipsum
                                                                                is
                                                                                simply
                                                                                dummy
                                                                                text
                                                                                of
                                                                                the
                                                                                <br />printing
                                                                                and
                                                                                typesetting
                                                                                industry.
                                                                                Lorem
                                                                                Ipsum.
                                                                            </p>
                                                                        </div>
                                                                    </div>
                                                                </div>
                                                            </td>
                                                            <td>4</td>
                                                            <td>$28.45</td>
                                                            <td>
                                                                Dec 22, 2020
                                                            </td>
                                                            <td>
                                                                <div
                                                                    class="table_btn"
                                                                >
                                                                    <a
                                                                        href="#"
                                                                        class="btn yellow_color"
                                                                        >On
                                                                        Hold</a
                                                                    >
                                                                    <a
                                                                        class="three_dots"
                                                                        href="#"
                                                                        ><img
                                                                            src="/maincss/images/threedots.svg"
                                                                    /></a>
                                                                    <p>
                                                                        Payment
                                                                        needed
                                                                    </p>
                                                                </div>
                                                            </td>
                                                        </tr>

                                                        <tr>
                                                            <td>
                                                                <a
                                                                    class="track_link"
                                                                    href="#"
                                                                >
                                                                    <div
                                                                        class="track_id d-flex"
                                                                    >
                                                                        <div
                                                                            class="track_id_content"
                                                                        >
                                                                            <form
                                                                                action=""
                                                                            >
                                                                                <input
                                                                                    type="checkbox"
                                                                                    id=""
                                                                                    name=""
                                                                                    value=""
                                                                                />110096500
                                                                            </form>
                                                                        </div>
                                                                    </div>
                                                                </a>
                                                            </td>
                                                            <td>
                                                                <div
                                                                    class="cloth_img"
                                                                >
                                                                    <img
                                                                        src="/maincss/images/adidas.png"
                                                                        alt=" "
                                                                    />
                                                                    <p>
                                                                        Embroidery
                                                                    </p>
                                                                </div>
                                                            </td>
                                                            <td>
                                                                <div
                                                                    class="port_comp d-flex"
                                                                >
                                                                    <img
                                                                        src="/maincss/images/adidas.png"
                                                                        alt=" "
                                                                    />
                                                                    Adidas
                                                                    weekende…
                                                                </div>
                                                            </td>
                                                            <td>6</td>
                                                            <td>$36.28</td>
                                                            <td>
                                                                Nov 19, 2020
                                                            </td>
                                                            <td>
                                                                <div
                                                                    class="table_btn"
                                                                >
                                                                    <a
                                                                        href="#"
                                                                        class="btn green_color"
                                                                        >Completed</a
                                                                    >
                                                                    <a
                                                                        class="three_dots"
                                                                        href="#"
                                                                        ><img
                                                                            src="/maincss/images/threedots.svg"
                                                                    /></a>
                                                                </div>
                                                            </td>
                                                        </tr>

                                                        <tr>
                                                            <td width="208px">
                                                                <a
                                                                    class="track_link"
                                                                    href="#"
                                                                >
                                                                    <div
                                                                        class="track_id d-flex"
                                                                    >
                                                                        <div
                                                                            class="track_id_content"
                                                                        >
                                                                            <form
                                                                                action=""
                                                                            >
                                                                                <input
                                                                                    type="checkbox"
                                                                                    id=""
                                                                                    name=""
                                                                                    value=""
                                                                                />110004100
                                                                            </form>
                                                                        </div>
                                                                    </div>
                                                                </a>
                                                            </td>
                                                            <td>
                                                                <div
                                                                    class="cloth_img"
                                                                >
                                                                    <img
                                                                        src="/maincss/images/port_athority.png"
                                                                        alt=" "
                                                                    />
                                                                    <p>Patch</p>
                                                                </div>
                                                            </td>
                                                            <td>
                                                                <div
                                                                    class="port_comp d-flex"
                                                                >
                                                                    <img
                                                                        src="/maincss/images/port_athority.png"
                                                                        alt=" "
                                                                    />
                                                                    Port
                                                                    authority…
                                                                </div>
                                                            </td>
                                                            <td>8</td>
                                                            <td>$92.40</td>
                                                            <td>
                                                                Nov 19, 2020
                                                            </td>
                                                            <td>
                                                                <div
                                                                    class="table_btn"
                                                                >
                                                                    <a
                                                                        href="#"
                                                                        class="btn purple_color"
                                                                        >New</a
                                                                    >
                                                                    <a
                                                                        class="three_dots"
                                                                        href="#"
                                                                        ><img
                                                                            src="/maincss/images/threedots.svg"
                                                                    /></a>
                                                                </div>
                                                            </td>
                                                        </tr>
                                                    </tbody>
                                                </table>
                                            </div>
                                        </div>
                                        <div
                                            class="tab-pane fade"
                                            id="nav-profile"
                                            role="tabpanel"
                                            aria-labelledby="nav-profile-tab"
                                        >
                                            <div
                                                class="account_table table-responsive mt_30"
                                            >
                                                <table class="table">
                                                    <thead>
                                                        <tr>
                                                            <th
                                                                class="d-flex order_id_column"
                                                                scope="col"
                                                            >
                                                                <form action="">
                                                                    <input
                                                                        type="checkbox"
                                                                        id=""
                                                                        name=""
                                                                        value=""
                                                                    />
                                                                </form>
                                                                ORDER ID
                                                            </th>
                                                            <th scope="col">
                                                                ARTWORK
                                                            </th>
                                                            <th scope="col">
                                                                <a href="#"
                                                                    >PRODUCT
                                                                    NAME
                                                                    <img
                                                                        alt=""
                                                                        src="/maincss/images/up-down-arrow.svg"
                                                                /></a>
                                                            </th>
                                                            <th scope="col">
                                                                QUANTITY
                                                            </th>
                                                            <th scope="col">
                                                                TOTAL COST
                                                            </th>
                                                            <th scope="col">
                                                                ORDERED ON
                                                            </th>
                                                            <th
                                                                class="status_btn"
                                                                scope="col"
                                                            >
                                                                STATUS
                                                            </th>
                                                        </tr>
                                                    </thead>
                                                    <tbody>
                                                        <tr>
                                                            <td>
                                                                <a
                                                                    class="track_link"
                                                                    href="#"
                                                                >
                                                                    <div
                                                                        class="track_id d-flex"
                                                                    >
                                                                        <div
                                                                            class="track_id_content"
                                                                        >
                                                                            <form
                                                                                action=""
                                                                            >
                                                                                <input
                                                                                    type="checkbox"
                                                                                    id=""
                                                                                    name=""
                                                                                    value=""
                                                                                />110004100
                                                                            </form>
                                                                            <p
                                                                                class="text-right"
                                                                            >
                                                                                24
                                                                                Hour
                                                                                T-Shirt
                                                                            </p>
                                                                        </div>
                                                                        <img
                                                                            src="/maincss/images/info.svg"
                                                                            alt=" "
                                                                        />
                                                                    </div>
                                                                </a>
                                                            </td>
                                                            <td>
                                                                <div
                                                                    class="cloth_img"
                                                                >
                                                                    <img
                                                                        src="/maincss/images/black_tshirt.png"
                                                                        alt=" "
                                                                    />
                                                                    <p>Print</p>
                                                                </div>
                                                            </td>
                                                            <td>
                                                                <div
                                                                    class="port_comp d-flex"
                                                                >
                                                                    <img
                                                                        src="/maincss/images/black_tshirt.png"
                                                                        alt=" "
                                                                    />
                                                                    Port &
                                                                    company…
                                                                </div>
                                                            </td>
                                                            <td>2</td>
                                                            <td>$18.00</td>
                                                            <td>
                                                                Dec 29, 2020
                                                            </td>
                                                            <td>
                                                                <div
                                                                    class="table_btn"
                                                                >
                                                                    <a
                                                                        href="#"
                                                                        class="btn"
                                                                        >In
                                                                        Progress</a
                                                                    >
                                                                    <a
                                                                        class="three_dots"
                                                                        href="#"
                                                                        ><img
                                                                            src="/maincss/images/threedots.svg"
                                                                    /></a>
                                                                </div>
                                                            </td>
                                                        </tr>
                                                    </tbody>
                                                    <tbody>
                                                        <tr>
                                                            <td>
                                                                <a
                                                                    class="track_link"
                                                                    href="#"
                                                                >
                                                                    <div
                                                                        class="track_id d-flex"
                                                                    >
                                                                        <div
                                                                            class="track_id_content"
                                                                        >
                                                                            <form
                                                                                action=""
                                                                            >
                                                                                <input
                                                                                    type="checkbox"
                                                                                    id=""
                                                                                    name=""
                                                                                    value=""
                                                                                />110051025
                                                                            </form>
                                                                        </div>
                                                                    </div>
                                                                </a>
                                                            </td>
                                                            <td>
                                                                <div
                                                                    class="cloth_img"
                                                                >
                                                                    <img
                                                                        src="/maincss/images/custome_classes.png"
                                                                        alt=" "
                                                                    />
                                                                    <p>
                                                                        Embroidery
                                                                    </p>
                                                                </div>
                                                            </td>
                                                            <td>
                                                                <div
                                                                    class="port_comp d-flex"
                                                                >
                                                                    <img
                                                                        src="/maincss/images/custome_classes.png"
                                                                        alt=" "
                                                                    />
                                                                    Custom
                                                                    classic,,,
                                                                </div>
                                                                <div
                                                                    class="bell_icon_text text-center position-relative"
                                                                >
                                                                    <a href="#"
                                                                        ><img
                                                                            src="/maincss/images/bell_icon.svg"
                                                                            alt=" "
                                                                        />
                                                                        Order
                                                                        status
                                                                        reports</a
                                                                    >
                                                                    <div
                                                                        class="table_dropdown"
                                                                    >
                                                                        <div
                                                                            class="dropdown_header_custome"
                                                                        >
                                                                            <h4
                                                                                class="link font_size_14 text_primary_blue py_6 px_8"
                                                                            >
                                                                                Note
                                                                            </h4>
                                                                        </div>
                                                                        <div
                                                                            class="dropdown_para"
                                                                        >
                                                                            <p
                                                                                class="font_size_12 py_6 px_8 mb-0"
                                                                            >
                                                                                Lorem
                                                                                Ipsum
                                                                                is
                                                                                simply
                                                                                dummy
                                                                                text
                                                                                of
                                                                                the
                                                                                <br />printing
                                                                                and
                                                                                typesetting
                                                                                industry.
                                                                                Lorem
                                                                                Ipsum.
                                                                            </p>
                                                                        </div>
                                                                    </div>
                                                                </div>
                                                            </td>
                                                            <td>4</td>
                                                            <td>$28.45</td>
                                                            <td>
                                                                Dec 22, 2020
                                                            </td>
                                                            <td>
                                                                <div
                                                                    class="table_btn"
                                                                >
                                                                    <a
                                                                        href="#"
                                                                        class="btn yellow_color"
                                                                        >On
                                                                        Hold</a
                                                                    >
                                                                    <a
                                                                        class="three_dots"
                                                                        href="#"
                                                                        ><img
                                                                            src="/maincss/images/threedots.svg"
                                                                    /></a>
                                                                    <p>
                                                                        Payment
                                                                        needed
                                                                    </p>
                                                                </div>
                                                            </td>
                                                        </tr>

                                                        <tr>
                                                            <td>
                                                                <a
                                                                    class="track_link"
                                                                    href="#"
                                                                >
                                                                    <div
                                                                        class="track_id d-flex"
                                                                    >
                                                                        <div
                                                                            class="track_id_content"
                                                                        >
                                                                            <form
                                                                                action=""
                                                                            >
                                                                                <input
                                                                                    type="checkbox"
                                                                                    id=""
                                                                                    name=""
                                                                                    value=""
                                                                                />110096500
                                                                            </form>
                                                                        </div>
                                                                    </div>
                                                                </a>
                                                            </td>
                                                            <td>
                                                                <div
                                                                    class="cloth_img"
                                                                >
                                                                    <img
                                                                        src="/maincss/images/adidas.png"
                                                                        alt=" "
                                                                    />
                                                                    <p>
                                                                        Embroidery
                                                                    </p>
                                                                </div>
                                                            </td>
                                                            <td>
                                                                <div
                                                                    class="port_comp d-flex"
                                                                >
                                                                    <img
                                                                        src="/maincss/images/adidas.png"
                                                                        alt=" "
                                                                    />
                                                                    Adidas
                                                                    weekende…
                                                                </div>
                                                            </td>
                                                            <td>6</td>
                                                            <td>$36.28</td>
                                                            <td>
                                                                Nov 19, 2020
                                                            </td>
                                                            <td>
                                                                <div
                                                                    class="table_btn"
                                                                >
                                                                    <a
                                                                        href="#"
                                                                        class="btn green_color"
                                                                        >Completed</a
                                                                    >
                                                                    <a
                                                                        class="three_dots"
                                                                        href="#"
                                                                        ><img
                                                                            src="/maincss/images/threedots.svg"
                                                                    /></a>
                                                                </div>
                                                            </td>
                                                        </tr>

                                                        <tr>
                                                            <td width="208px">
                                                                <a
                                                                    class="track_link"
                                                                    href="#"
                                                                >
                                                                    <div
                                                                        class="track_id d-flex"
                                                                    >
                                                                        <div
                                                                            class="track_id_content"
                                                                        >
                                                                            <form
                                                                                action=""
                                                                            >
                                                                                <input
                                                                                    type="checkbox"
                                                                                    id=""
                                                                                    name=""
                                                                                    value=""
                                                                                />110004100
                                                                            </form>
                                                                        </div>
                                                                    </div>
                                                                </a>
                                                            </td>
                                                            <td>
                                                                <div
                                                                    class="cloth_img"
                                                                >
                                                                    <img
                                                                        src="/maincss/images/port_athority.png"
                                                                        alt=" "
                                                                    />
                                                                    <p>Patch</p>
                                                                </div>
                                                            </td>
                                                            <td>
                                                                <div
                                                                    class="port_comp d-flex"
                                                                >
                                                                    <img
                                                                        src="/maincss/images/port_athority.png"
                                                                        alt=" "
                                                                    />
                                                                    Port
                                                                    authority…
                                                                </div>
                                                            </td>
                                                            <td>8</td>
                                                            <td>$92.40</td>
                                                            <td>
                                                                Nov 19, 2020
                                                            </td>
                                                            <td>
                                                                <div
                                                                    class="table_btn"
                                                                >
                                                                    <a
                                                                        href="#"
                                                                        class="btn purple_color"
                                                                        >New</a
                                                                    >
                                                                    <a
                                                                        class="three_dots"
                                                                        href="#"
                                                                        ><img
                                                                            src="/maincss/images/threedots.svg"
                                                                    /></a>
                                                                </div>
                                                            </td>
                                                        </tr>
                                                    </tbody>
                                                </table>
                                            </div>
                                        </div>
                                        <div
                                            class="tab-pane fade show active"
                                            id="nav-contact"
                                            role="tabpanel"
                                            aria-labelledby="nav-contact-tab"
                                        >
                                            <div
                                                class="account_table table-responsive mt_30"
                                            >
                                                <table class="table">
                                                    <thead>
                                                        <tr>
                                                            <th
                                                                class="d-flex order_id_column"
                                                                scope="col"
                                                            >
                                                                <form action="">
                                                                    <input
                                                                        type="checkbox"
                                                                        id=""
                                                                        name=""
                                                                        value=""
                                                                    />
                                                                </form>
                                                                ORDER ID
                                                            </th>
                                                            <th scope="col">
                                                                ARTWORK
                                                            </th>
                                                            <th scope="col">
                                                                <a href="#"
                                                                    >PRODUCT
                                                                    NAME
                                                                    <img
                                                                        alt=""
                                                                        src="/maincss/images/up-down-arrow.svg"
                                                                /></a>
                                                            </th>
                                                            <th scope="col">
                                                                QUANTITY
                                                            </th>
                                                            <th scope="col">
                                                                TOTAL COST
                                                            </th>
                                                            <th scope="col">
                                                                ORDERED ON
                                                            </th>
                                                            <th
                                                                class="status_btn"
                                                                scope="col"
                                                            >
                                                                STATUS
                                                            </th>
                                                        </tr>
                                                    </thead>
                                                    <tbody>
                                                        <tr>
                                                            <td>
                                                                <a
                                                                    class="track_link"
                                                                    href="#"
                                                                >
                                                                    <div
                                                                        class="track_id d-flex"
                                                                    >
                                                                        <div
                                                                            class="track_id_content"
                                                                        >
                                                                            <form
                                                                                action=""
                                                                            >
                                                                                <input
                                                                                    type="checkbox"
                                                                                    id=""
                                                                                    name=""
                                                                                    value=""
                                                                                />110004100
                                                                            </form>
                                                                            <p
                                                                                class="text-right"
                                                                            >
                                                                                24
                                                                                Hour
                                                                                T-Shirt
                                                                            </p>
                                                                        </div>
                                                                        <img
                                                                            src="/maincss/images/info.svg"
                                                                            alt=" "
                                                                        />
                                                                    </div>
                                                                </a>
                                                            </td>
                                                            <td>
                                                                <div
                                                                    class="cloth_img"
                                                                >
                                                                    <img
                                                                        src="/maincss/images/black_tshirt.png"
                                                                        alt=" "
                                                                    />
                                                                    <p>Print</p>
                                                                </div>
                                                            </td>
                                                            <td>
                                                                <div
                                                                    class="port_comp d-flex"
                                                                >
                                                                    <img
                                                                        src="/maincss/images/black_tshirt.png"
                                                                        alt=" "
                                                                    />
                                                                    Port &
                                                                    company…
                                                                </div>
                                                            </td>
                                                            <td>2</td>
                                                            <td>$18.00</td>
                                                            <td>
                                                                Dec 29, 2020
                                                            </td>
                                                            <td>
                                                                <div
                                                                    class="table_btn"
                                                                >
                                                                    <a
                                                                        href="#"
                                                                        class="btn"
                                                                        >In
                                                                        Progress</a
                                                                    >
                                                                    <a
                                                                        class="three_dots"
                                                                        href="#"
                                                                        ><img
                                                                            src="/maincss/images/threedots.svg"
                                                                    /></a>
                                                                </div>
                                                            </td>
                                                        </tr>
                                                    </tbody>
                                                    <tbody>
                                                        <tr>
                                                            <td>
                                                                <a
                                                                    class="track_link"
                                                                    href="#"
                                                                >
                                                                    <div
                                                                        class="track_id d-flex"
                                                                    >
                                                                        <div
                                                                            class="track_id_content"
                                                                        >
                                                                            <form
                                                                                action=""
                                                                            >
                                                                                <input
                                                                                    type="checkbox"
                                                                                    id=""
                                                                                    name=""
                                                                                    value=""
                                                                                />110051025
                                                                            </form>
                                                                        </div>
                                                                    </div>
                                                                </a>
                                                            </td>
                                                            <td>
                                                                <div
                                                                    class="cloth_img"
                                                                >
                                                                    <img
                                                                        src="/maincss/images/custome_classes.png"
                                                                        alt=" "
                                                                    />
                                                                    <p>
                                                                        Embroidery
                                                                    </p>
                                                                </div>
                                                            </td>
                                                            <td>
                                                                <div
                                                                    class="port_comp d-flex"
                                                                >
                                                                    <img
                                                                        src="/maincss/images/custome_classes.png"
                                                                        alt=" "
                                                                    />
                                                                    Custom
                                                                    classic,,,
                                                                </div>
                                                                <div
                                                                    class="bell_icon_text text-center position-relative"
                                                                >
                                                                    <a href="#"
                                                                        ><img
                                                                            src="/maincss/images/bell_icon.svg"
                                                                            alt=" "
                                                                        />
                                                                        Order
                                                                        status
                                                                        reports</a
                                                                    >
                                                                    <div
                                                                        class="table_dropdown"
                                                                    >
                                                                        <div
                                                                            class="dropdown_header_custome"
                                                                        >
                                                                            <h4
                                                                                class="link font_size_14 text_primary_blue py_6 px_8"
                                                                            >
                                                                                Note
                                                                            </h4>
                                                                        </div>
                                                                        <div
                                                                            class="dropdown_para"
                                                                        >
                                                                            <p
                                                                                class="font_size_12 py_6 px_8 mb-0"
                                                                            >
                                                                                Lorem
                                                                                Ipsum
                                                                                is
                                                                                simply
                                                                                dummy
                                                                                text
                                                                                of
                                                                                the
                                                                                <br />printing
                                                                                and
                                                                                typesetting
                                                                                industry.
                                                                                Lorem
                                                                                Ipsum.
                                                                            </p>
                                                                        </div>
                                                                    </div>
                                                                </div>
                                                            </td>
                                                            <td>4</td>
                                                            <td>$28.45</td>
                                                            <td>
                                                                Dec 22, 2020
                                                            </td>
                                                            <td>
                                                                <div
                                                                    class="table_btn"
                                                                >
                                                                    <a
                                                                        href="#"
                                                                        class="btn yellow_color"
                                                                        >On
                                                                        Hold</a
                                                                    >
                                                                    <a
                                                                        class="three_dots"
                                                                        href="#"
                                                                        ><img
                                                                            src="/maincss/images/threedots.svg"
                                                                    /></a>
                                                                    <p>
                                                                        Payment
                                                                        needed
                                                                    </p>
                                                                </div>
                                                            </td>
                                                        </tr>

                                                        <tr>
                                                            <td>
                                                                <a
                                                                    class="track_link"
                                                                    href="#"
                                                                >
                                                                    <div
                                                                        class="track_id d-flex"
                                                                    >
                                                                        <div
                                                                            class="track_id_content"
                                                                        >
                                                                            <form
                                                                                action=""
                                                                            >
                                                                                <input
                                                                                    type="checkbox"
                                                                                    id=""
                                                                                    name=""
                                                                                    value=""
                                                                                />110096500
                                                                            </form>
                                                                        </div>
                                                                    </div>
                                                                </a>
                                                            </td>
                                                            <td>
                                                                <div
                                                                    class="cloth_img"
                                                                >
                                                                    <img
                                                                        src="/maincss/images/adidas.png"
                                                                        alt=" "
                                                                    />
                                                                    <p>
                                                                        Embroidery
                                                                    </p>
                                                                </div>
                                                            </td>
                                                            <td>
                                                                <div
                                                                    class="port_comp d-flex"
                                                                >
                                                                    <img
                                                                        src="/maincss/images/adidas.png"
                                                                        alt=" "
                                                                    />
                                                                    Adidas
                                                                    weekende…
                                                                </div>
                                                            </td>
                                                            <td>6</td>
                                                            <td>$36.28</td>
                                                            <td>
                                                                Nov 19, 2020
                                                            </td>
                                                            <td>
                                                                <div
                                                                    class="table_btn"
                                                                >
                                                                    <a
                                                                        href="#"
                                                                        class="btn green_color"
                                                                        >Completed</a
                                                                    >
                                                                    <a
                                                                        class="three_dots"
                                                                        href="#"
                                                                        ><img
                                                                            src="/maincss/images/threedots.svg"
                                                                    /></a>
                                                                </div>
                                                            </td>
                                                        </tr>

                                                        <tr>
                                                            <td width="208px">
                                                                <a
                                                                    class="track_link"
                                                                    href="#"
                                                                >
                                                                    <div
                                                                        class="track_id d-flex"
                                                                    >
                                                                        <div
                                                                            class="track_id_content"
                                                                        >
                                                                            <form
                                                                                action=""
                                                                            >
                                                                                <input
                                                                                    type="checkbox"
                                                                                    id=""
                                                                                    name=""
                                                                                    value=""
                                                                                />110004100
                                                                            </form>
                                                                        </div>
                                                                    </div>
                                                                </a>
                                                            </td>
                                                            <td>
                                                                <div
                                                                    class="cloth_img"
                                                                >
                                                                    <img
                                                                        src="/maincss/images/port_athority.png"
                                                                        alt=" "
                                                                    />
                                                                    <p>Patch</p>
                                                                </div>
                                                            </td>
                                                            <td>
                                                                <div
                                                                    class="port_comp d-flex"
                                                                >
                                                                    <img
                                                                        src="/maincss/images/port_athority.png"
                                                                        alt=" "
                                                                    />
                                                                    Port
                                                                    authority…
                                                                </div>
                                                            </td>
                                                            <td>8</td>
                                                            <td>$92.40</td>
                                                            <td>
                                                                Nov 19, 2020
                                                            </td>
                                                            <td>
                                                                <div
                                                                    class="table_btn"
                                                                >
                                                                    <a
                                                                        href="#"
                                                                        class="btn purple_color"
                                                                        >New</a
                                                                    >
                                                                    <a
                                                                        class="three_dots"
                                                                        href="#"
                                                                        ><img
                                                                            src="/maincss/images/threedots.svg"
                                                                    /></a>
                                                                </div>
                                                            </td>
                                                        </tr>
                                                    </tbody>
                                                </table>
                                            </div>
                                        </div>
                                        <div class="row">
                                            <div class="col-md-12">
                                                <nav
                                                    aria-label="Page navigation example"
                                                    class="mt_40"
                                                >
                                                    <ul class="pagination">
                                                        <li
                                                            class="page-item previous"
                                                        >
                                                            <a
                                                                class="page-link"
                                                                href="#"
                                                                ><img
                                                                    src="/maincss/images/previous_arrow.svg"
                                                                    alt=""
                                                                    class="mr_10"
                                                                />
                                                                Previous</a
                                                            >
                                                        </li>
                                                        <li
                                                            class="page-item active"
                                                        >
                                                            <a
                                                                class="page-link"
                                                                href="#"
                                                                >1</a
                                                            >
                                                        </li>
                                                        <li class="page-item">
                                                            <a
                                                                class="page-link"
                                                                href="#"
                                                                >2</a
                                                            >
                                                        </li>
                                                        <li class="page-item">
                                                            <a
                                                                class="page-link"
                                                                href="#"
                                                                >3</a
                                                            >
                                                        </li>
                                                        <li
                                                            class="page-item next active"
                                                        >
                                                            <a
                                                                class="page-link"
                                                                href="#"
                                                                >Next
                                                                <img
                                                                    src="/maincss/images/next_arrow.svg"
                                                                    alt=""
                                                                    class="ml_10"
                                                            /></a>
                                                        </li>
                                                    </ul>
                                                </nav>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </section>
    </div>
</template>

<script>
export default {
    name: "MyStoredetail",
    components: {},
    mounted() {
        // document.body.classList.add('cart-custom-class');
        /* eslint-disable */
        $(function () {
            $("#item2").click(function () {
                $("#submenu2").slideToggle(500);
            });
        });
        /* eslint-enable */
    }
};
</script>
